<template>
  <DropdownOptions class="mr-2 MultipleSelectOptions" :options="options">
    <template v-for="(_, name) in $scopedSlots"
      slot-scope="slotData"
      :slot="name"

      v-if="name"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>

    <span class="mulit-select-handle">
      <slot>
        Acties
      </slot>
    </span>
  </DropdownOptions>
</template>

<script>

import DropdownOptions from "../DropdownOptions.vue"

export default {
  props: {
    options: {
      type: Array,
      required: true,
    }
  },
  components: {
    DropdownOptions,
  },
}

</script>

<style scoped>

.mulit-select-handle {
  font-size: 13px;
}

</style>
